import $i18n from '@/lang/index';

export const headerList = [
  {
    id: 1,
    label: $i18n.t('routes.flowName'),
    prop: 'flowDirectName',
    cloWidth: 150,
    center: 'center',
    rowspan: true
  },
  {
    id: 2,
    label: $i18n.t('routes.departureTransferCenter'),
    prop: 'departTransferCenterName',
    cloWidth: 160,
    center: 'center',
    rowspan: true
  },
  {
    id: 3,
    label: $i18n.t('routes.trunkLine'),
    prop: 'typeName',
    cloWidth: 160,
    center: 'center',
    rowspan: true
  },
  {
    id: 333,
    label: $i18n.t('routes.班次编号'),
    prop: 'scheduleNumber',
    cloWidth: 160,
    center: 'center',
    rowspan: true
  },
  {
    id: 334,
    label: $i18n.t('routes.latestArrivalTime'),
    prop: 'latestArriveTime',
    cloWidth: 160,
    center: 'center',
    rowspan: true
  },
  {
    id: 4,
    label: $i18n.t('routes.发车时间'),
    prop: 'departureTime',
    cloWidth: 160,
    center: 'center',
    rowspan: true
  },
  // 登记时间
  {
    id: 5,
    label: $i18n.t('routes.下一站流向'),
    prop: 'nextSiteName',
    cloWidth: 150,
    center: 'center'
  },
  {
    id: 6,
    label: $i18n.t('routes.estimatedArrivalTime'),
    prop: 'expectedArriveTime',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 7,
    label: $i18n.t('routes.crossDay'),
    prop: 'acrossDayName',
    cloWidth: 160,
    center: 'center'
  },
  {
    id: 8,
    label: $i18n.t('GlobalSetObj.editor'),
    prop: 'updateUserName',
    cloWidth: 160,
    center: 'center',
    rowspan: true
  },
  {
    id: 9,
    label: $i18n.t('GlobalSetObj.LastModified'),
    prop: 'updateTime',
    cloWidth: 160,
    center: 'center',
    rowspan: true
  }
];
